import { resetOffCanvasView, selectAskQuestionId, selectAskResults, selectQuestionAskedImage, selectQuestionAskedText } from "@/store/slices/offCanvas";
import { Dialog } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import Portal from "@/layouts/Portal";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import SimilarBlock from "@/components/Similar/SimilarBlock";
import Image from "next/image";
import FaClose from "@/components/SVG/Fontawesome/FaClose";

const SearchResultsModal = () => {
  const questionId = useSelector(selectAskQuestionId);
  const dispatch = useDispatch();
  const img = useSelector(selectQuestionAskedImage);
  const text = useSelector(selectQuestionAskedText);
  const askResults = useSelector(selectAskResults);

  const MathJaxConfig = {
    loader: { load: ["input/asciimath", "output/chtml"] }
  };

  const closeModal = () => {
    dispatch(resetOffCanvasView());
  }

  return (
    <>
      <Dialog open={!!questionId} as="div" className="relative z-[1055]" onClose={closeModal}>
        <div className="fixed inset-0 bg-black/75" />
        <Portal>
          <div className="fixed inset-0 overflow-y-auto flex flex-col justify-center items-center">
            <div className="flex flex-col gap-2 items-center justify-center h-full overflow-y-auto max-h-[90vh]">
              <Dialog.Panel className="max-w-screen-md w-full flex justify-end text-white">
                <button onClick={closeModal}>
                  Close <FaClose />
                </button>
              </Dialog.Panel>
              <Dialog.Title className="max-w-screen-md w-full">
                {
                  img && <Image src={img}
                    alt="Question Image"
                    width={10}
                    height={31}
                    priority
                    className="card w-full max-h-96 object-contain my-0"
                  />
                }
                {
                  text && <div className="card w-full max-h-96 my-0 flex gap-1">
                    <h2>Q:</h2>
                    <p>{text}</p>
                  </div>
                }
              </Dialog.Title>
              <Dialog.Panel className="relative max-w-screen-md flex flex-col w-full transform overflow-y-auto align-middle bg-body-bg rounded-lg p-4">
                <MathJaxContext config={MathJaxConfig}>
                  <div className="flex flex-col gap-2">
                    {
                      askResults.map((ques: any) =>
                        <MathJax inline dynamic key={ques._id}>
                          <SimilarBlock data={{ ...ques._source, question_id: ques._id }} similarMathJax={ques._source.ocr_text} target="_blank" />
                        </MathJax>
                      )
                    }
                  </div>
                </MathJaxContext>
              </Dialog.Panel>
            </div>
          </div>
        </Portal>
      </Dialog>
    </>
  )
}

export default SearchResultsModal;